import * as request from "@/utils/request";
import { AcctStatusRes, PayinInfo } from "./types";
import { DefaultConfigs } from "@/common/js/constant";

const baseUrl = `${DefaultConfigs.publicAPIPath}`;

// 查询账户状态
export function getAcctStatus() {
  return request.get<AcctStatusRes>(`${baseUrl}/sofipo/v0/user/queryAcctStatus`, {});
}

// 获取充值页地址
export function getPayinUrl() {
  return request.post<PayinInfo>(`${baseUrl}/sofipo/v0/trade/payin/create`, {});
}
